<div class="card border border-disabled my-lg-4 mb-4">
  <div class="card-content px-3 my-lg-auto">
    <div class="row">
      <div class="col-lg-5">
        <h5 class="mt-lg-2 mb-lg-0 mb-3 fw-bold text-primary">
          {{ 'voucher.title' | translate }}
        </h5>
      </div>
      <div class="col-lg-4">
        <span class="input-group">
          <input
            type="text"
            [(ngModel)]="voucherCode"
            placeholder="INSERT CODE HERE"
            class="form-control text-center border-0 px-5 px-lg-0"
            (keyup.enter)="redeemVoucher()"
          />
          <div class="input-group-append">
            <button
              class="btn btn-primary icon text-white fw-bold material-icons py-0 px-1 d-flex align-items-center"
              type="button"
              (click)="redeemVoucher()"
              [disabled]="disableButton"
            >
              <span class="icon material-icons"> keyboard_arrow_right </span>
            </button>
          </div>
        </span>
        <div class="text-center position-absolute text-result ps-lg-5">
          <fgb-errors></fgb-errors>
        </div>

        <div class="result text-center position-absolute text-result ps-lg-5" *ngIf="redemptionResult">
          <div class="font-size-12 mt-1" [ngClass]="!!sucessfulRedemption ? 'text-success' : 'text-black'">
            {{ redemptionResult }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
